import React from "react";
import { FC } from "react";
import { useMemo } from "react";
import { useAuth } from "../../modules/auth/hooks/useAuth";

interface AccessControlProps {
  keepEmpty?: boolean;
  verified?: boolean;
  allowedRoles?: number[];
  renderNoAccess?: Function;
}

const AccessControl: FC<AccessControlProps> = React.memo(
  ({
    children,
    keepEmpty,
    verified: needsToBeVerified,
    allowedRoles,
    renderNoAccess,
  }) => {
    const { user } = useAuth();

    const roleMatches = useMemo(() => {
      if (!allowedRoles || allowedRoles.length === 0) {
        return true;
      }
      return allowedRoles && allowedRoles.includes(Number(user && user.role));
    }, [user, allowedRoles]);

    const permitted = useMemo(() => user && roleMatches, [user, roleMatches]);
    const verified = useMemo(
      () =>
        !(
          typeof needsToBeVerified != "undefined" &&
          !needsToBeVerified &&
          !(user && user.verified)
        ),
      [user, needsToBeVerified],
    );

    if (verified && permitted) {
      return children;
    }
    if (verified && keepEmpty) {
      return <></>;
    }
    if (renderNoAccess && typeof renderNoAccess === "function") {
      return renderNoAccess();
    } else {
      return null;
    }
  },
);

interface ConditionalViewProps {
  children;
  condition;
}

export const ConditionalView: FC<ConditionalViewProps> = React.memo(
  ({ condition, children }) => {
    if (condition) {
      return children;
    }
    return null;
  },
);

export default AccessControl;
